import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import iconBackArrow from "../../assets/icons/back-arrow-filled.svg";
import { AnimationData } from "../../assets/glb/animations";
import { getAnimationByTokens } from "../../utils/animationHandle";
import { validateEmail } from "../../utils/regex";
import LibrasIcon from "../../assets/icons/libras-icon.svg";
import { LibrasButtonMenu } from "../LibrasButtonMenu";
import { Dropdown, DropdownItemType } from "../../components/Dropdown";
import { CameraModal } from "../CameraModal";
import { FileModal } from "../FileModal";
import arrowIcon from "../../assets/icons/back-arrow.svg";

import {
  AttendantMenuContainer,
  ConfirmButton,    
  Container,
  CancelButton,
  Header
} from "./styles";
import { SendVideo } from "../SendVideo";
import { ErrorMessage } from "../Dropdown/styles";

interface AttendantProps {
  setAnimation?: React.Dispatch<React.SetStateAction<AnimationData[]>>;
  onBack: () => void;
}

export function Attendant({
  setAnimation,
  onBack
}: AttendantProps) {
  const [email, setEmail] = useState("");
  const [content, setContent] = useState("");
  const [validEmail, setValidEmail] = useState<boolean>(false);
  const [askSended, setAskSended] = useState(false);
  const [scenarios, setScenarios] = useState<DropdownItemType[]>([]);
  const [selectedScenario, setSelectedScenario] = useState<string>("");
  const [showCameraModal, setShowCameraModal] = useState(false);
  const [showFileModal, setShowFileModal] = useState(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [videoBlob, setVideoBlob] = useState<Blob | null>(null);
  const [loadingLibrasKey, setLoadingLibrasKey] = useState<"help" | "sent" | null>(null);
  const [formError, setFormError] = useState("");
  useEffect (()=> {
    const checkScreen =()=> {
      setIsMobile(window.innerWidth <769 )
    }
    checkScreen();
    window.addEventListener('resize',checkScreen)
    return ()=> window.removeEventListener('resize',checkScreen)  
  },[])
  
  useEffect(() => {
    const scenariosData = localStorage.getItem("scenarios");
    if (!scenariosData) {
      return;
    }

    try {
      const parsed = JSON.parse(scenariosData);
      setScenarios([
        ...(Array.isArray(parsed) ? parsed : []),
        {
          glosa: 'OUTRA_COISA',
          id: -1,
          icon: '',
          name: 'Outro Tópico'
        }
      ]);
    } catch (error) {
      console.error("Valor inválido em localStorage['scenarios']:", error);
      localStorage.removeItem("scenarios");
      setScenarios([
        {
          glosa: 'OUTRA_COISA',
          id: -1,
          icon: '',
          name: 'Outro Tópico'
        }
      ]);
    }
  }, []);

  function handleBack() {
    onBack();
  }

  function handleVideo(file:any) {
    const blob = new Blob([file], { type: file.type });
    setVideoBlob(blob);
  }

  function checkValidEmail(email: string){
    if (validateEmail.test(email)) {
      setValidEmail(true);
    } else {
      setValidEmail(false);
    }
  }

  function playLibrasWithLoading(key: "help" | "sent", glosaText: string) {
    setLoadingLibrasKey(key);

    const handleStarted = () => {
      setLoadingLibrasKey(null);
      window.removeEventListener("LISA_ANIMATION_STARTED", handleStarted);
    };

    window.addEventListener("LISA_ANIMATION_STARTED", handleStarted, { once: true });

    window.dispatchEvent(new CustomEvent("LISA_INTERRUPT"));

    getAnimationByTokens(glosaText)
      .then((animations) => {
        if (setAnimation) setAnimation(animations);
        window.dispatchEvent(new CustomEvent("LISA_RESUME"));
      })
      .catch(() => {
        setLoadingLibrasKey(null);
      })
      .finally(() => {
        setLoadingLibrasKey(null);
      });
  }


  function getScenarioFromSelected(){
    return scenarios.find((item) => item.name === selectedScenario)
  }

  async function sendVideoReq(link: string, file: File) {
    try {
      const res = await fetch(link, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type,
        },
      });

      if (!res.ok) {
        throw new Error("Falha no envio do video");
      }

      setAskSended(true);
    } catch (error) {
      console.error("Erro ao enviar vídeo:", error);
    }
  }


  async function sendHelpCase(): Promise<void> {

    if(!validEmail){
      setFormError("Insira um email válido, que termine com @dell.com ou @dellteam.com");
      return
    }
    else if (!email || !validEmail || !selectedScenario || (!content && !videoBlob)) {
      setFormError("Preencha todos os campos com dados válidos.");
      return;
    }

    setFormError("");
    try {
      const path = process.env.REACT_APP_API_URL;

      const fileName =
        videoBlob instanceof File
          ? videoBlob.name
          : "gravacao.webm";

      const mimeType = videoBlob?.type ?? null;


      const data: any = {
        content,
        requester_email: email,
        scenario_id: getScenarioFromSelected()?.id,
      };

      if (videoBlob) {
        data.file_name = fileName;
        data.mimetype = mimeType;
      }

      const options = {
        method: "POST",
        url: `${path}/helpcase`,
        headers: {
          "Content-Type": "application/json",
        },
        data,
      };

      return axios
        .create({withCredentials: true})
        .request(options)
        .then((response) => {
          if (videoBlob) {
            const file =
              videoBlob instanceof File
                ? videoBlob
                : new File(
                  [videoBlob],
                  fileName,
                  { type: mimeType ?? "video/webm" }
                );

            sendVideoReq(response.data.url, file);
          }
          else{
            setAskSended(true);
          }
        });
    } catch (error) {
      console.error("Erro ao enviar mensagem:", error);
    }
  }

  const handleLibrasSelection = useCallback((detection: string) => {
    if (detection === 'voltar') {
      handleBack();
    }
  }, [scenarios]);

  useEffect(() => {
    const onLibrasEvent = (event: any) => {
      const num = event.detail.number;
      handleLibrasSelection(num);
    };

    window.addEventListener("LIBRAS_SELECTION", onLibrasEvent);

    return () => {
      window.removeEventListener("LIBRAS_SELECTION", onLibrasEvent);
    };
  }, [handleLibrasSelection]);

  return (
    <Container>
      {/* <Header>
        <button onClick={handleBack} className="back-button hint" data-hint="Voltar" data-hint-placement="bottom">
          <img src={arrowIcon} alt="Voltar" />
        </button>
        <h1>Atendimento</h1>
      </Header> */}

      {!askSended ? (
        <AttendantMenuContainer>
          <div className="titleContainer">
            <div className="title">
              <span>Nos conte sua dúvida</span>
              <LibrasButtonMenu
                disabled={loadingLibrasKey === "help"}
                onClick={() =>
                  playLibrasWithLoading(
                    "help",
                    "VOCE CONTATO ATENDIMENTO DIGITAR EMAIL CERTO"
                  )
                }
              >
                {loadingLibrasKey === "help" ? (
                  <span className="btnSpinner" />
                ) : (
                  <img src={LibrasIcon} alt="Ícone Libras" />
                )}
              </LibrasButtonMenu>

            </div>
            <span className="sub">
              Você pode gravar um vídeo, enviar um arquivo ou escrever sua dúvida em texto aqui embaixo.
            </span>
          </div>
          {formError && (
            <ErrorMessage>
              <span>{formError}</span>
            </ErrorMessage>
          )}
          <div className="AttendantContainer">
            <div className="inputContainer">
              <input
                  value={email}
                  onChange={(event) => {
                    setEmail(event.target.value);
                    checkValidEmail(event.target.value);
                  }}
                  type="email"
                  id="email"
                  placeholder="Digite seu e-mail @dell.com ou @dellteam.com"
                  tabIndex={4}
              />
                <Dropdown
                  items={scenarios}
                  value={selectedScenario}
                  onChange={setSelectedScenario}
                  placeholder="Sobre o que você quer tirar dúvidas?"
                />
              <input
                  placeholder="Informe aqui sua dúvida"
                  type="text"
                  onChange={(event) => setContent(event.target.value)}
                  tabIndex={6}
              />
              <SendVideo
                setVideoBlob={setVideoBlob}
              />
            </div>
          </div>

          <div className="buttonContainer">
            <CancelButton type="button" onClick={handleBack}>
              Cancelar
            </CancelButton>
            <ConfirmButton type="button" onClick={sendHelpCase}>
              Enviar
            </ConfirmButton>
          </div>
          {showFileModal && (
            <FileModal onClose={() => setShowFileModal(false)} />
          )}
          {showCameraModal && (
            <CameraModal onClose={() => setShowCameraModal(false)} />
          )}

        </AttendantMenuContainer>
      ) : (
        <AttendantMenuContainer>
          <div className="titleContainer">
            <div className="title">
              <span>Enviado!</span>
              <LibrasButtonMenu
                disabled={loadingLibrasKey === "sent"}
                onClick={() =>
                  playLibrasWithLoading(
                    "sent",
                    "SEU ENVIAR JA VAI RECEBER RESPOSTA ATE 24 HORA_VAR"
                  )
                }
              >
                {loadingLibrasKey === "sent" ? (
                  <span className="btnSpinner" />
                ) : (
                  <img src={LibrasIcon} alt="Ícone Libras" />
                )}
              </LibrasButtonMenu>

            </div>
            <span className="sub">
              Sua dúvida foi enviada! Você receberá a resposta em até 24 horas.
            </span>
          </div>
        </AttendantMenuContainer>
      )}
    </Container>
  );
}
